module.exports = __webpack_public_path__ + "img/shebeistatus3.0160abdf.jpg";